import script from "./FileUploader.vue?vue&type=script&setup=true&lang=ts"
export * from "./FileUploader.vue?vue&type=script&setup=true&lang=ts"

import "./FileUploader.vue?vue&type=style&index=0&id=dfaef5b0&scoped=true&lang=css"

import exportComponent from "/home/forge/tenant.mybcr.dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dfaef5b0"]])

export default __exports__